import { HEAD } from '@/tools/constant.js'

import moment from 'moment'; //导入模块
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn'); 
import { nanoid } from "nanoid"

export const formatNumber = val => val >= 10 ? val : '0' + val

export function fakeData(value = 4) {
  let fakeData = []
  for(let i = 0; i < value; i++) {
    fakeData.push({id: nanoid(), title: 'loading', type: 26})
  }
  return fakeData
}

export function isHead(value) {
  let empty = require("@/assets/images/load.jpg") // 加载中
  let err = require("@/assets/images/load.jpg") // 加载失败
  if(value) {
    if(value === 'load') {
      return empty
    } else if(value === 'err') {
      return err
    } else {
      if (value.match(new RegExp("^http")) || value.match(new RegExp("^//"))) {
        return value
      } else {
        return HEAD + value
      }
    }
    
  } else {
    return err
  }
}
// 检查数组是否存在某值
export function isArr (str, arr = []) {
  if (arr.indexOf(str.toString()) == -1) {
    return false
  } else {
    return true
  }
}
// 时间戳转时间
export function formatTime(time, str) {
  return moment(new Date(time)).format(str)
}

// 倒计时 按天计算
export function count_down(time) {
  if (time) {
    let day = parseInt(time / 1000 / 60 / 60 / 24)
    let hour = parseInt((time % 86400000) / 1000 / 60 / 60)
    let minute = parseInt((time % 86400000 % 3600000) / 1000 / 60)
    let second = parseInt((time % 86400000 % 3600000 % 60000) / 1000)
    return `${day}天${hour}时${minute}分${second}秒`
  } else {
    return
  }
}

// 手机号正则
export function validateTel(tel) {
  let phoneReg = /^[1][0-9]{10}$/;
  return phoneReg.test(tel)
}
// 身份证 -- 验证
export function validateIdent(card) {
  let cardReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  return cardReg.test(card)
}

// 身份证 -- 获取生日
export function getBirthdayIdcard(idcard = "") {
  if (validateIdent(idcard)) {
    let birthday = idcard.substring(6, 14);
    return birthday.replace(/(.{4})(.{2})/, "$1-$2-");
  } else {
    console.error("身份证号码有误")
  }
}

// 身份证 -- 年龄获取
export function getAgeIdcard(idcard = "") {
  if (validateIdent(idcard)) {
    //时间字符串里，必须是“/”
    let birthDate = new Date(getBirthdayIdcard(idcard).replace(/-/g, '/'));
    let nowDateTime = new Date();
    let age = nowDateTime.getFullYear() - birthDate.getFullYear();
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
      age--;
    }
    return age
  } else {
    console.error("身份证号码有误")
  }
}

// 身份证 -- 性别获取
export function getSexIdcard(idcard = "") {
  if (validateIdent(idcard)) {
    if (parseInt(idcard.substring(16, 17)) % 2 == 1) {
      return [0, '男']
    } else {
      return [1, '女']
    }
  } else {
    console.error("身份证号码有误")
  }
}

// 证件打*  str：要进行隐藏的变量  frontLen: 前面需要保留几位    endLen: 后面需要保留几位 xx: 要显示几个 *
export const hideZj = (str, frontLen = 1, endLen = 1, xx = 3) => {
  let xing = '';
  for (let i = 0; i < xx; i++) {
    xing += '*';
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
}